import { HttpBackend } from "@angular/common/http";
import { importProvidersFrom, inject } from "@angular/core";
import { Routes } from "@angular/router";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

import { PrivacyGuard } from "@intocare/auth";
import { safelyCloseOverlay } from "@intocare/design/design-system-base";
import { CacheBustMultiTranslateHttpLoader, TranslationLoaderResolverFn } from "@intocare/language";
import { CONTEXT_TOKEN } from "@intocare/util";

import { RestrictiveMeasuresOverlay } from "./containers/restrictive-measures.overlay";

export const portalGlobalOverlayRoutes: Routes = [
	{
		path: "view-restrictive-measures/residents/:residentId",
		outlet: "aside",
		canActivate: [PrivacyGuard],
		data: {
			redirectTo: "..",
			queryParamsHandling: "preserve",
		},
		providers: [
			importProvidersFrom(
				TranslateModule.forChild({
					extend: true,
					loader: {
						provide: TranslateLoader,
						useFactory(httpBackend: HttpBackend) {
							return new CacheBustMultiTranslateHttpLoader(httpBackend, [
								"assets/design/design-system-base/i18n/",
								"assets/features/observations/i18n/",
							]);
						},
						deps: [HttpBackend],
					},
				}),
			),
		],
		resolve: {
			translations: TranslationLoaderResolverFn,
			siteId() {
				return inject(CONTEXT_TOKEN).context().currentSite.id;
			},
		},
		canDeactivate: [safelyCloseOverlay],
		component: RestrictiveMeasuresOverlay,
	},
];
